// extracted by mini-css-extract-plugin
export default {"propertyHeader":"style-module--property-header--479f0","containerFluid":"style-module--container-fluid--69a1e"};